// Re-export shared formatters from canonical source (ISO 25010 — DRY)
export { formatCurrency, formatCurrencyExact, formatDate, formatDateShort, formatPercent, formatNumber } from '../lib/utils';

export function createPageUrl(pageName, params = {}) {
  const kebab = pageName
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
    .replace(/([a-z\d])([A-Z])/g, '$1-$2')
    .toLowerCase();
  const path = kebab.startsWith('/') ? kebab : `/${kebab}`;
  if (!params || Object.keys(params).length === 0) return path;
  return `${path}?${new URLSearchParams(params).toString()}`;
}